import { render, staticRenderFns } from "./IconBackspaceSolid.vue?vue&type=template&id=ee658a68"
import script from "./IconBackspaceSolid.vue?vue&type=script&lang=js"
export * from "./IconBackspaceSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports